export default __webpack_public_path__ + "static/media/male-photo3.2dc71695.jpg";